import { Inject } from '@odinjs/odin';
import { FetchAPI, ModalService, ThemeTonalRange } from '@philips-internal/oswald-ui-components';
import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import './index.css';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { ApprovalPhasesDetailsAPI } from '@philips-internal/pending-approval-components';

import BaseController from '../../BaseController';

@Controller({ fragment: 'purchase-approval', component: 'layout-main' })
export default class PurchaseApprovalController extends BaseController {

  @Inject('approval-phases-details')
    approvalPhasesDetailsApi: ApprovalPhasesDetailsAPI;

  @Inject('fetch-phases')
    phasesFetchApi: FetchAPI;

  @OnMount('layout-main')
  onBeforeFetchApprovalItem(): void {
    const { phasesFetchApi } = this;
    const historyParams = this.historyService.getCurrentRouteParams();
    const id = historyParams && typeof historyParams.id !== 'undefined' ? String(historyParams.id) : '0';
    phasesFetchApi.setParameters({ sequence: id });
    phasesFetchApi.forceFetch();
  }

  @OnClick({ target: 'approval-phases-card' })
  onPhases(event: ClickEvent): void {
    const { note } = event.value;
    this.onClickDeckNote(String(note));
  }

  onClickDeckNote(note: string): void {
    ModalService.openFullscreen({
      closeable: true,
      fragment: 'modal-note',
      onClose: () => {return;},
      title: 'approval.note',
      focusOnOpen: true,
      theme: ThemeTonalRange.ULTRA_LIGHT,
      contextData: {
        note,
      },
    });
  }

}
